module.exports = __webpack_public_path__ + "poster-bj.png?0709b663558dce33457366cc6b884573";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/poster-bj.png
// module id = 40
// module chunks = 0